var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 94,
    viewBox: "0 0 108 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.557 14.546L98.1389 93.7908L46.5673 87.6605L38.8093 86.7394L37.0589 86.5306L36.9382 86.5172L37.2293 84.0717L37.4821 81.9536L42.1396 42.7477L46.1135 9.31013L46.3548 7.27438L62.2041 9.15692L107.557 14.546Z",
    fill: "#00A868"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6159 73.1556C81.4914 73.1556 81.3765 73.0732 81.3401 72.9468L63.4187 9.66634C63.3746 9.51313 63.4646 9.35418 63.6159 9.31204C63.7691 9.268 63.9281 9.35801 63.9702 9.5093L81.8936 72.7898C81.9376 72.943 81.8476 73.102 81.6963 73.1441C81.6676 73.1518 81.6427 73.1556 81.6159 73.1556Z",
    fill: "#1D232A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0388 79.7742L43.1968 86.973L38.8093 86.4464L38.997 84.2363L42.1397 42.3283L44.6772 8.50197L46.2284 7.78955L63.696 9.58783L82.0388 79.7742Z",
    fill: "#1D232A",
    stroke: "#1D232A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6012 0.209227L0.442627 13.6141L17.7996 91.5088L77.9581 78.1039L60.6012 0.209227Z",
    fill: "#E8E9EA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5785 26.3372C12.4464 26.3372 12.3276 26.2453 12.2989 26.1132C12.2644 25.9581 12.3621 25.8048 12.5172 25.7704L54.8274 16.3405C54.9825 16.3041 55.1357 16.4037 55.1702 16.5588C55.2046 16.7139 55.107 16.8671 54.9519 16.9016L12.6417 26.3315C12.6206 26.3353 12.5996 26.3372 12.5785 26.3372Z",
    fill: "#1D232A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3283 38.6762C15.1961 38.6762 15.0774 38.5843 15.0487 38.4522C15.0142 38.297 15.1119 38.1438 15.267 38.1093L57.5771 28.6794C57.7304 28.643 57.8855 28.7426 57.9199 28.8977C57.9544 29.0528 57.8567 29.2061 57.7016 29.2405L15.3915 38.6686C15.3704 38.6724 15.3493 38.6762 15.3283 38.6762Z",
    fill: "#1D232A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0783 51.0133C17.9461 51.0133 17.8274 50.9214 17.7987 50.7892C17.7642 50.6341 17.8619 50.4809 18.017 50.4464L60.3272 41.0164C60.4823 40.982 60.6355 41.0796 60.67 41.2348C60.7045 41.3899 60.6068 41.5431 60.4517 41.5776L18.1415 51.0056C18.1204 51.0095 18.0993 51.0133 18.0783 51.0133Z",
    fill: "#1D232A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8288 63.3503C20.6966 63.3503 20.5779 63.2603 20.5492 63.1262C20.5147 62.9711 20.6124 62.8179 20.7675 62.7834L63.0777 53.3535C63.2328 53.319 63.386 53.4167 63.4205 53.5718C63.455 53.7269 63.3573 53.8801 63.2022 53.9146L20.892 63.3446C20.869 63.3484 20.8479 63.3503 20.8288 63.3503Z",
    fill: "#1D232A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5768 75.6873C23.4447 75.6873 23.3259 75.5973 23.2972 75.4633C23.2627 75.3081 23.3604 75.1549 23.5155 75.1205L53.3719 68.4654C53.5251 68.431 53.6802 68.5286 53.7147 68.6838C53.7492 68.8389 53.6515 68.9921 53.4964 69.0266L23.64 75.6816C23.6189 75.6854 23.5979 75.6873 23.5768 75.6873Z",
    fill: "#1D232A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenBook);
export default __webpack_public_path__ + "static/media/GreenBook.86d615ef2b696b7fbf7b9fff6e06bf59.svg";
export { ForwardRef as ReactComponent };